import clsx from 'clsx';
import { Icon } from '../layout/Icon.jsx';
import { viewAllNotice } from './viewAll.js';

/**
 * زر التبديل بين «عرض الكل» والصفحات — واحد لكل الجداول كي يتصرّفوا بنفس الشكل.
 */
export function ViewAllToggle({ all, onChange, total, shown, className }) {
  return (
    <button
      type="button"
      className={clsx('btn btn-sm', all && 'btn-primary', className)}
      onClick={() => onChange(!all)}
      title={all ? 'العودة إلى العرض بصفحات' : 'عرض جميع السجلات بلا صفحات'}
    >
      <Icon name={all ? 'chevronR' : 'chevronD'} size={13} />
      {all
        ? `عرض بصفحات${Number(total) ? ` (${Number(shown || 0).toLocaleString('en-US')})` : ''}`
        : 'عرض الكل'}
    </button>
  );
}

/** سطر التنبيه عند تجاوز سقف العرض — لا يظهر إن كانت النتائج كاملة. */
export function ViewAllNotice({ all, shown, total }) {
  if (!all) return null;
  const note = viewAllNotice(shown, total);
  if (!note) return null;
  return (
    <div className="text-[11.5px] text-ink-3 mt-2 px-1" style={{ color: '#B45309' }}>
      {note}
    </div>
  );
}
